module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAPCAYAAAA2yOUNAAAAjElEQVQokY3SsQrCMBAG4FORYnX0gcXZJxBxcBB1FUFQ0Pdx08HxcyqmUdoeZAkfl/yXBGZ4YoEeIl+Bt28t/8HAUb3WGORojHsGNymsdIlrBrcVTM8ucc7gAcM8SYFTBlc/cTHBI0GvftSriIhdREyTvX3aYdR2pxKXpnRj3Nrm1Gnind5ujpeGX/ABGNmwj1Irqx4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/modules/fronend/images/arrow-right.png
// module id = ./src/assets/modules/fronend/images/arrow-right.png
// module chunks = 2 3